import React, { FC, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Icon, Tag, Tooltip } from '@wmgtech/legato'

import { getCoverImagePath } from 'shared/utils/getCoverImagePath'
import { formatDate } from 'shared/utils/formatDate'

import { GpsBadge } from 'components'
import { useZoneTag } from 'modulesCommon/serviceHooks'

import { ProductsListItemProps } from './ProductsListItem.props'
import './ProductListItem.scss'

const ProductsListItem: FC<ProductsListItemProps> = ({ product, units }) => {
  const { isSameLabel, isSpace, label } = useZoneTag(`${product.campaign.label_id}`)

  const isReleasedDateChanged = useMemo(
    () => product?.publish_date?.split('T')[0] !== product?.properties?.initial_release_date?.split('T')[0],
    [product]
  )

  const genre = product.campaign.artist?.gcdm_info?.genre ?? 'N/A'

  return (
    <Link to={`/projects/${product.campaign_id}`}>
      <div className="product">
        <img
          className="product__avatar"
          alt={product.id || 'Product image'}
          src={getCoverImagePath(product.parent_id)}
        />
        <div className="product__col">
          <div className="product-title__campaign-name">{product.campaign?.artist?.name}</div>
          {product.campaign?.artist?.gps_status ? (
            <GpsBadge gpsStatus={product.campaign?.artist?.gps_status} coloredBackground />
          ) : null}
        </div>
        <div className="product__col">
          <div className="product-title__product-name">
            <div>
              {product.name} |<i>Genre: {genre}</i>
            </div>
            {product?.gps_status ? <GpsBadge gpsStatus={product.gps_status} coloredBackground /> : null}
          </div>
        </div>
        {isSpace ? (
          <div className="product__col">
            <div className="product-title__product-name">
              {label ? (
                <Tag
                  size={'xs'}
                  removable={false}
                  rounded
                  text={label.alias}
                  colorType={isSameLabel ? 'white' : 'dark'}
                  containerStyle={isSameLabel ? 'outline' : 'solid'}
                  className="story-header-title__tag"
                  tooltip
                  tooltipText={label.name}
                />
              ) : null}
            </div>
          </div>
        ) : null}
        <div className="product__col product__col--configuration">{product.configuration}</div>
        <div className="product__col">{units.find(({ id }: any) => id === `${product.campaign?.unit_id}`)?.name}</div>
        <div className="product__col product__col--release">
          <div className={isReleasedDateChanged ? 'product__col-changed' : ''}>
            {formatDate({ date: product.publish_date, withTime: false })}
          </div>
          {isReleasedDateChanged && (
            <Tooltip message="New Release Date" placement="top" colorType="dark">
              <Icon className="product__col-tooltip" name="circle-info" prefix="fas" />
            </Tooltip>
          )}
        </div>
      </div>
    </Link>
  )
}

export default ProductsListItem
